export { GenericFunction } from './GenericFunction';

// Series Function Exports
import { SeriesFunction } from './SeriesFunction/SeriesFunction';
import { average } from './SeriesFunction/methods/average';
import { cumulativeSum } from './SeriesFunction/methods/cumulativeSum';
import { extendIndex } from './SeriesFunction/methods/extendIndex';
import { growth } from './SeriesFunction/methods/growth';

const exportSeriesFuncs = [average, cumulativeSum, extendIndex, growth];

export { SeriesFunction, average, cumulativeSum, extendIndex, growth };


// Value Function Exports
import { ValueFunction } from './ValueFunction/ValueFunction';
import { add } from './ValueFunction/methods/add';
import { divide } from './ValueFunction/methods/divide';
import { identity } from './ValueFunction/methods/identity';
import { multiply } from './ValueFunction/methods/multiply';
import { plusX } from './ValueFunction/methods/plusX';
import { product } from './ValueFunction/methods/product';
import { productTimesX } from './ValueFunction/methods/productTimesX';
import { simplePayment } from './ValueFunction/methods/simplePayment';
import { subtract } from './ValueFunction/methods/subtract';
import { sum } from './ValueFunction/methods/sum';


const exportValueFuncs = [add, divide, identity, multiply, plusX, product, productTimesX, simplePayment, subtract, sum];

export { ValueFunction, add, divide, identity, multiply, plusX, product, productTimesX, simplePayment, subtract, sum };


// Auto Regressive Function Exports
import { ARFunction } from './ARFunction/ARFunction';
import { loanPaydown } from './ARFunction/methods/loanPaydown';

const exportARFuncs = [loanPaydown];

export { ARFunction, loanPaydown };



// Automatically store all function in a label-to-function mapping
let exportFuncs = [...exportValueFuncs, ...exportSeriesFuncs, ...exportARFuncs];
export const labelToFunction = {};

for (let func of exportFuncs) {
  if (func) { // Handle strange Jest issue where imports are unresolved
    labelToFunction[func.label] = func;
  }
}

